<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader type="card"> </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-for="n in 6" :key="n">
      <v-col cols="4" v-for="n in 3" :key="n">
        <v-skeleton-loader type="button" class="skeleton-button">
        </v-skeleton-loader>
        <v-skeleton-loader
          type="list-item-three-line"
          class="skeleton-list-item-three-line"
        >
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-fooldal-skeleton',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
};
</script>
